import React, { Component } from 'react'
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import UploadImage from '../utils/UploadImage';
import { base } from '../../base';
import '../../styles/css/AdminMain.css';
import swal from 'sweetalert2';
import RichTextMarkdown from "../utils/RichTextMarkdown";
import ColorPicker from "../utils/ColorPicker";
import {isEmptyHtmlEntity} from "../utils/HelpfulFunction";

class SetUpTeamVariables extends Component {
    constructor(props) {
        super(props);
        this.UploadImage = new UploadImage();
        this.state = {
            tenantVariables: {},
            showTabOneMajor: true,
            showTabTwoMajor: false,
            showTabThreeMajor: false,
            showTabOneMinor: true,
            showTabTwoMinor: false,
            showTabThreeMinor: false,
            loading:true,
            colorsTab: true,
            advanced: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    }

    componentDidMount() {
        this.tenantVariablesRef = base.bindToState(`tenantVariables`, {
            context: this,
            state: 'tenantVariables',
            then(){
                const variables = this.state.tenantVariables || {};
                if(variables.globalPrizeWonHeader || variables.globalPrizeWonBody || variables.globalNoPrizeHeader || variables.globalNoPrizeBody){
                    this.setState({
                        advanced: true
                    })
                }
            }
        });
        this.setState({
            loading: false
        })
    }

    componentWillUnmount() {
      base.removeBinding(this.tenantVariablesRef);
    }

    handleRichTextChange = (name, text) => {
        let tenantVariablesCopy = this.state.tenantVariables;
        if(isEmptyHtmlEntity(text)){
            text = "";
        }
        tenantVariablesCopy[name] = text;
        this.setState({ tenantVariables:  tenantVariablesCopy});
    }

    handleSubmit(event) {
      event.preventDefault();
      const variables = this.state.tenantVariables;
      const vm = this;
      base.post("tenantVariables/", {
        data: variables,
        then(err){
          vm.setState({loading:false})
          if(!err){
            swal({
                title: 'Tenant Variables Updated!',
                type: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: true,
                timer: 10000
              })
          } else {
            swal({
                title: 'There was some error!',
                text: 'Try again and if the problem persists try logging out and logging back in',
                type: 'error',
                confirmButtonText: 'Ok'
              })
            // console.log(err)
          }
        }
      })
    }

    handleChange(event){
        let target = event.target;
        let value = target.value;
        if(target.type === 'checkbox'){
            value = target.checked;
            this.setState({[target.name]: value})
        } else {
            let tenantVariablesCopy = this.state.tenantVariables;
            tenantVariablesCopy[event.target.name] = value
            this.setState({ tenantVariables:  tenantVariablesCopy});
        }
    }

    handleImageChange(event){
      const name_of_file = event.target.name;
      const target = this[name_of_file];
      const file_to_update =target.files[0];
      this.setState({loading:true});
      const vm = this;
      this.UploadImage.upload_file(file_to_update).then(res => {
          vm.setState({loading:false})
          if(res.error) {
              swal({
                  title: 'Image cannot be uploaded',
                  text: res.error,
                  type: 'warning',
                  confirmButtonText: 'Ok'
              })
          } else if(res.imageUrl) {
              const tenantVariablesCopy = vm.state.tenantVariables;
              tenantVariablesCopy[name_of_file] = res.imageUrl;
              vm.setState({
                  tenantVariables: tenantVariablesCopy,
              }, () => {
                  vm[name_of_file].value = ""
              });
          } else {
              swal({
                  title: 'Image cannot be uploaded',
                  text: 'There was some issue with the image upload, please check the image type and size and try again',
                  type: 'warning',
                  confirmButtonText: 'Ok'
              })
          }
      })
    }

    toggleColors(){
        if(this.state.colorsTab){
            document.getElementById('showColors').classList.remove('active');
            document.getElementById('showImages').classList.add('active');
        } else {
            document.getElementById('showColors').classList.add('active');
            document.getElementById('showImages').classList.remove('active');
        }
        this.setState({colorsTab: !this.state.colorsTab})
    }

    tripleToggleControl(element, whichToggle){
        const tabOne = "showTabOne" + whichToggle;
        const tabTwo = "showTabTwo" + whichToggle;
        const tabThree = "showTabThree" + whichToggle;
        const firstElement = document.getElementById('showfirst' + whichToggle);
        const secondElement = document.getElementById('showsecond' + whichToggle);
        const thirdElement = document.getElementById('showthird' + whichToggle);
        if(element === "first"){
            firstElement.classList.add('active');
            secondElement.classList.remove('active');
            if(thirdElement){
                thirdElement.classList.remove('active');
            }
            this.setState({
                [tabOne]: true,
                [tabTwo]: false,
                [tabThree]: false,
            })
        }else if(element === "second"){
            firstElement.classList.remove('active');
            secondElement.classList.add('active');
            if(thirdElement){
                thirdElement.classList.remove('active');
            }
            this.setState({
                [tabOne]: false,
                [tabTwo]: true,
                [tabThree]: false,
            })
        } else {
            firstElement.classList.remove('active');
            secondElement.classList.remove('active');
            if(thirdElement){
                thirdElement.classList.add('active');
            }
            this.setState({
                [tabOne]: false,
                [tabTwo]: false,
                [tabThree]: true,
            })
        }
    }

    render() {
        const tenantVariables = this.state.tenantVariables || {};
        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <p className="admin-header-text" style={{marginBottom:0, marginTop:'5px'}}>Game Branding</p>
                <p className="admin-subheader-text">This is where you can edit the game branding on your activation</p>
                <div className="container-out">
                  <div className="admin-form-box" style={{marginTop:'0px', paddingTop:'5px'}}>
                    <form onSubmit={this.handleSubmit} id="create-game-form">
                      <button className="btn btn-primary btn-lg update-button" id="submitButton" style={{marginBottom:'20px'}}><span className="fa fa-arrow-circle-o-up"/> Update</button>
                      <ul className="nav nav-tabs nav-justified nav-bordered mb-3">
                          <li className="nav-item" onClick={()=> this.tripleToggleControl('first', 'Major')}>
                              <a href="#" aria-expanded="false" className="nav-link active" id="showfirstMajor">
                                  <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Fan Color/Images</span>
                              </a>
                          </li>
                          <li className="nav-item" onClick={()=> this.tripleToggleControl('second', 'Major')}>
                              <a href="#" aria-expanded="true" className="nav-link" id="showsecondMajor">
                                  <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Scoreboard Color/Images</span>
                              </a>
                          </li>
                          <li className="nav-item" onClick={()=> this.tripleToggleControl('third', 'Major')}>
                              <a href="#" aria-expanded="true" className="nav-link" id="showthirdMajor">
                                  <i className="mdi mdi-account-circle d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Game Text</span>
                              </a>
                          </li>
                      </ul>
                        <ul className="nav nav-tabs nav-justified nav-bordered mb-3" style={{display: this.state.showTabOneMajor === true ? '' : 'none'}}>
                            <li className="nav-item" onClick={()=> this.toggleColors()}>
                                <a href="#" aria-expanded="false" className="nav-link active" id="showColors">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Colors</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.toggleColors()}>
                                <a href="#" aria-expanded="true" className="nav-link" id="showImages">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Images</span>
                                </a>
                            </li>
                        </ul>
                        <ul className="nav nav-tabs nav-justified nav-bordered mb-3" style={{display: this.state.showTabTwoMajor === true ? '' : 'none'}}>
                            <li className="nav-item" onClick={()=> this.tripleToggleControl("first", "Minor")}>
                                <a href="#" aria-expanded="false" className="nav-link active" id="showfirstMinor">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Colors</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.tripleToggleControl("second", "Minor")}>
                                <a href="#" aria-expanded="true" className="nav-link" id="showsecondMinor">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Images</span>
                                </a>
                            </li>
                            <li className="nav-item" onClick={()=> this.tripleToggleControl("third", "Minor")}>
                                <a href="#" aria-expanded="true" className="nav-link" id="showthirdMinor">
                                    <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                    <span className="d-none d-lg-block">Timing/Blur</span>
                                </a>
                            </li>
                        </ul>
                      <div style={{display: this.state.showTabOneMajor ? 'block' : 'none'}}>
                          <div style={{display: this.state.colorsTab ? 'block': 'none'}}>
                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Button Colors</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="primaryColor"
                                                  label="Button Color"
                                                  value={this.state.tenantVariables.primaryColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'primaryColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>

                                          <div style={{height:'10px', width:'100%'}}/>

                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="secondaryColor"
                                                  label="Button Text Color"
                                                  value={this.state.tenantVariables.secondaryColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'secondaryColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <h4>Logout Color</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="logOutButtonColor"
                                                  label="Button Color"
                                                  value={this.state.tenantVariables.logOutButtonColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'logOutButtonColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div style={{height:'10px', width:'100%'}}/>
                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Game Colors</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="textColor"
                                                  label="Text Color"
                                                  value={this.state.tenantVariables.textColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'textColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>

                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="highlightPickColor"
                                                  label="Highlight Pick Color"
                                                  value={this.state.tenantVariables.highlightPickColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'highlightPickColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <h4>Other Colors</h4>
                                      <div className="form-inline">
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="hintColor"
                                                  label="Hint Color"
                                                  value={this.state.tenantVariables.hintColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'hintColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="glowColor"
                                                  label="Glow / Accent Color"
                                                  value={this.state.tenantVariables.glowColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'glowColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                          <div style={{height:'10px', width:'100%'}}/>
                                          <div style={{display: "flex", alignItems: "center"}}>
                                              <ColorPicker
                                                  name="progressBarColor"
                                                  label="Progress Bar Color"
                                                  value={this.state.tenantVariables.progressBarColor}
                                                  onChange={hex =>
                                                      this.handleChange({
                                                          target: { name: 'progressBarColor', value: hex }
                                                      })
                                                  }
                                              />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                            <div style={{display: this.state.colorsTab ? 'none': 'block'}}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="admin-grid-container three-columns" style={{display: "flex",  alignItems: 'flex-end', justifyContent: 'space-evenly'}}>
                                          <div className="form-group" style={{textAlign:'center', margin:20}}>
                                            <img src={this.state.tenantVariables.backgroundImage} width="160" height="auto" alt=""/>
                                            <br/>
                                            <label htmlFor="backgroundImage">Phone Background Image<br/>(750px X 1334px)</label>
                                            <div className="form-group">
                                              <input style={{display:'none'}} id="backgroundImage" name="backgroundImage" type="file" ref={input => {this.backgroundImage = input; }} onChange={this.handleImageChange}/>
                                              <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('backgroundImage').click()} />
                                            </div>
                                          </div>
                                          <div className="form-group" style={{textAlign:'center', margin:20}}>
                                            <img src={this.state.tenantVariables.frontLogoImage} width="150" height="auto" alt=""/>
                                            <br/>
                                            <label htmlFor="frontLogoImage">Front Logo<br/>(700px X 700px)</label>
                                            <div className="form-group">
                                              <input style={{display:'none'}} id="frontLogoImage" name="frontLogoImage" type="file" ref={input => {this.frontLogoImage = input; }} onChange={this.handleImageChange}/>
                                              <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('frontLogoImage').click()} />
                                            </div>
                                          </div>
                                          <div className="form-group" style={{float:'left', textAlign:'center', margin:20}}>
                                            <img src={this.state.tenantVariables.topLeftImage} width="100" height="auto" alt=""/>
                                            <br/>
                                            <label htmlFor="topLeftImage">Top Logo<br/>(200px X 200px)</label>
                                            <div className="form-group">
                                                <input style={{display:'none'}} id="topLeftImage" name="topLeftImage" type="file" ref={input => {this.topLeftImage = input; }} onChange={this.handleImageChange}/>
                                                <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('topLeftImage').click()} />
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                      </div>

                      <div style={{display: this.state.showTabTwoMajor ? 'block' : 'none'}}>
                          <div style={{display: this.state.showTabOneMinor ? 'block': 'none'}}>
                              <h4>Scoreboard Colors</h4>
                              <div className="form-inline">
                                  <div style={{display: "flex", alignItems: "center"}}>
                                      <ColorPicker
                                          name="scoreboardHintColor"
                                          label="Scoreboard Hint Color"
                                          value={this.state.tenantVariables.scoreboardHintColor}
                                          onChange={hex =>
                                              this.handleChange({
                                                  target: { name: 'scoreboardHintColor', value: hex }
                                              })
                                          }
                                      />
                                  </div>
                                  <div style={{height:'10px', width:'100%'}}/>
                              </div>
                          </div>
                          <div style={{display: this.state.showTabTwoMinor ? 'block' : 'none'}}>
                              <div className="row">
                                  <div className="col-md-12">
                                      <div className="admin-grid-container three-columns" style={{display: "flex",  alignItems: 'flex-end', justifyContent: 'space-evenly'}}>
                                          <div className="form-group" style={{textAlign:'center', margin:20}}>
                                              <img src={this.state.tenantVariables.scoreboardBackgroundImage} width="160" height="auto" alt=""/>
                                              <br/>
                                              <label htmlFor="backgroundImage">Background Image<br/>(1920px X 1080px)</label>
                                              <div className="form-group">
                                                  <input style={{display:'none'}} id="scoreboardBackgroundImage" name="scoreboardBackgroundImage" type="file" ref={input => {this.scoreboardBackgroundImage = input; }} onChange={this.handleImageChange}/>
                                                  <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('scoreboardBackgroundImage').click()} />
                                              </div>
                                          </div>
                                          <div className="form-group" style={{textAlign:'center', margin:20}}>
                                              <img src={this.state.tenantVariables.sponsorImage} width="160px" height="auto" alt=""/>
                                              <br/>
                                              <label htmlFor="sponsorImage">Sponsor Image<br/>(800px X 800px)</label>
                                              <div className="form-group">
                                                  <input style={{display:'none'}} id="sponsorImage" name="sponsorImage" type="file" ref={input => {this.sponsorImage = input; }} onChange={this.handleImageChange}/>
                                                  <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('sponsorImage').click()} />
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div style={{display: this.state.showTabThreeMinor ? 'block' : 'none'}}>
                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Timing</h4>
                                      <div className="form-inline">
                                          <label htmlFor="timeToDeblur" style={{marginRight: 10}}>Time To Deblur (secs)</label>
                                          <input id="timeToDeblur" name="timeToDeblur" type="number" className="form-control" value={this.state.tenantVariables.timeToDeblur} onChange={this.handleChange} placeholder="30"/>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <h4>Blur</h4>
                                      <div className="form-inline">
                                          <label htmlFor="startingBlurAmount" style={{marginRight: 10}}>Starting Blur Amount (warning: will not work once the scoreboard has been started)</label>
                                          <input id="startingBlurAmount" name="startingBlurAmount" type="number" className="form-control" value={this.state.tenantVariables.startingBlurAmount} onChange={this.handleChange} placeholder="50"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                        <div style={{display: this.state.showTabThreeMajor ? 'block' : 'none'}}>
                            <div className="form-group">
                                <label htmlFor="pageTitle">Page Title:</label>
                                <input id="pageTitle" name="pageTitle" type="text" className="form-control" value={this.state.tenantVariables.pageTitle} onChange={this.handleChange} placeholder="Reveal"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="playingTextHeader">Header Playing Text:</label>
                                <input id="playingTextHeader" name="playingTextHeader" type="text" className="form-control" value={this.state.tenantVariables.playingTextHeader} onChange={this.handleChange} placeholder="Next game starts during"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="gameOverHeader">Too Late Header Text:</label>
                                <input id="gameOverHeader" name="gameOverHeader" type="text" className="form-control" value={this.state.tenantVariables.gameOverHeader} onChange={this.handleChange} placeholder="Game Already Ended!"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="gameOverBody">Too Late Body Text:</label>
                                <input id="gameOverBody" name="gameOverBody" type="text" className="form-control" value={this.state.tenantVariables.gameOverBody} onChange={this.handleChange} placeholder="The game already happened, come back next time to play."/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="playingText">Playing Text:</label>
                                <input id="playingText" name="playingText" type="text" className="form-control" value={this.state.tenantVariables.playingText} onChange={this.handleChange} placeholder="2nd Quarter"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="hintTextLabel">Hint Text Label:</label>
                                <input id="hintTextLabel" name="hintTextLabel" type="text" className="form-control" value={this.state.tenantVariables.hintTextLabel} onChange={this.handleChange} placeholder="HINT"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="showAdvancedSettings">Advanced</label>
                                <br/>
                                <input type="checkbox" checked={this.state.advanced} id="advanced" name="advanced" onChange={this.handleChange}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="loginFormHeader">Login Form Header</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "loginFormHeader",
                                        name: "loginFormHeader",
                                        value: tenantVariables.loginFormHeader || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('loginFormHeader', value)
                                    }}
                                    placeholder=""
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="aboveFormText">Above Form Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "aboveFormText",
                                        name: "aboveFormText",
                                        value: tenantVariables.aboveFormText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('aboveFormText', value)
                                    }}
                                    placeholder="Enter text above the form"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="aboveSubmitButtonText">Above Submit Button Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "aboveSubmitButtonText",
                                        name: "aboveSubmitButtonText",
                                        value: tenantVariables.aboveSubmitButtonText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('aboveSubmitButtonText', value)
                                    }}
                                    placeholder="Enter text above the submit button"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="belowSubmitButtonText">Below Submit Button Text</label>
                                <RichTextMarkdown
                                    field={{
                                        id: "belowSubmitButtonText",
                                        name: "belowSubmitButtonText",
                                        value: tenantVariables.belowSubmitButtonText || ""
                                    }}
                                    form={{
                                        setFieldValue: (field, value) => this.handleRichTextChange('belowSubmitButtonText', value)
                                    }}
                                    placeholder="Enter text below the submit button"
                                />
                            </div>
                            {this.state.advanced &&
                                <>
                                    <div className="form-group">
                                        <label htmlFor="globalPrizeWonHeader">Global Prize Won Header:</label>
                                        <input id="globalPrizeWonHeader" name="globalPrizeWonHeader" type="text" className="form-control" value={this.state.tenantVariables.globalPrizeWonHeader} onChange={this.handleChange} placeholder="You Win!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalPrizeWonBody">Global Prize Body:</label>
                                        <input id="globalPrizeWonBody" name="globalPrizeWonBody" type="text" className="form-control" value={this.state.tenantVariables.globalPrizeWonBody} onChange={this.handleChange} placeholder="Check your inbox for your prize!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoPrizeHeader">Global No Prize Header:</label>
                                        <input id="globalNoPrizeHeader" name="globalNoPrizeHeader" type="text" className="form-control" value={this.state.tenantVariables.globalNoPrizeHeader} onChange={this.handleChange} placeholder="Nice Job!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoPrizeBody">Global No Prize Body:</label>
                                        <input id="globalNoPrizeBody" name="globalNoPrizeBody" type="text" className="form-control" value={this.state.tenantVariables.globalNoPrizeBody} onChange={this.handleChange} placeholder="Unfortunately you didn't win a prize!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoneCorrectPrizeHeader">Global None Correct Prize Header:</label>
                                        <input id="globalNoneCorrectPrizeHeader" name="globalNoneCorrectPrizeHeader" type="text" className="form-control" value={this.state.tenantVariables.globalNoneCorrectPrizeHeader} onChange={this.handleChange} placeholder="Nice Job!"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="globalNoneCorrectPrizeBody">Global None Correct Prize Body:</label>
                                        <input id="globalNoneCorrectPrizeBody" name="globalNoneCorrectPrizeBody" type="text" className="form-control" value={this.state.tenantVariables.globalNoneCorrectPrizeBody} onChange={this.handleChange} placeholder="Unfortunately you didn't win a prize!"/>
                                    </div>
                                </>
                            }
                        </div>
                    </form>
                  </div>
                </div>
            </div>
         </div>
        );
    }
}

export default SetUpTeamVariables;
